<template>
  <div>
    <ItemHeader
      :title="`Доверитель № ${v.number.$model}`"
      :expand="expand"
      :btn-delete-visible="canDelete"
      btn-delete-text="Удалить доверителя"
      @btn-expand-click="expand = !expand"
      @btn-delete-click="$emit('delete')"
    />

    <v-expand-transition>
      <div v-show="expand">
        <div class="form-section-base__controls">
          <v-row>
            <v-col>
              <v-radio-group v-model="v.role.$model" row>
                <v-radio label="Физическое лицо" :value="Role.PERSON" />
                <v-radio label="Юридическое лицо" :value="Role.ORGANIZATION" />
                <v-radio
                  label="Иностранное юридическое лицо"
                  :value="Role.FOREIGN_ORGANIZATION"
                />
              </v-radio-group>
            </v-col>
          </v-row>
        </div>

        <ProxyTrusteePerson
          v-if="v.role.$model === Role.PERSON"
          :v="v.person"
        />

        <ProxyTrusteeOrganization
          v-if="v.role.$model === Role.ORGANIZATION"
          :v="v.organization"
        />

        <ProxyTrusteeForeignOrganization
          v-if="v.role.$model === Role.FOREIGN_ORGANIZATION"
          :v="v.foreignOrganization"
        />
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
import cloneDeep from 'clone-deep';

import { Role } from '@/utils/dictionaries';
import ItemHeader from '@/components/services/elements/ItemHeader';
import ProxyTrusteePerson, {
  proxyTrusteePersonModel,
  proxyTrusteePersonValidation,
} from './ProxyTrusteePerson';
import ProxyTrusteeOrganization, {
  proxyTrusteeOrganizationModel,
  proxyTrusteeOrganizationValidation,
} from './ProxyTrusteeOrganization';
import ProxyTrusteeForeignOrganization, {
  proxyTrusteeForeignOrganizationModel,
  proxyTrusteeForeignOrganizationValidation,
} from './ProxyTrusteeForeignOrganization';

export const proxyTrusteeModel = {
  role: Role.PERSON,
  number: 1,
  person: cloneDeep(proxyTrusteePersonModel),
  organization: cloneDeep(proxyTrusteeOrganizationModel),
  foreignOrganization: cloneDeep(proxyTrusteeForeignOrganizationModel),
};

export const proxyTrusteeValidation = {
  role: {},
  number: {},
  person: proxyTrusteePersonValidation,
  organization: proxyTrusteeOrganizationValidation,
  foreignOrganization: proxyTrusteeForeignOrganizationValidation,
};

export default {
  name: 'ProxyTrustee',
  props: {
    v: {
      type: Object,
      required: true,
    },
    canDelete: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    ItemHeader,
    ProxyTrusteePerson,
    ProxyTrusteeOrganization,
    ProxyTrusteeForeignOrganization,
  },
  data: () => ({
    Role,
    expand: true,
  }),
};
</script>
